module.exports = __webpack_public_path__ + "img/img2.9a4e2c4d.png";